<template>
  <PopUpModal
    ref="popup"
    :horizontal-align="popupHorizontalAlign"
    :horizontal-offset="popupHorizontalOffset"
    :z-index="popupZIndex"
  >
    <div
      class="m-3"
      :class="contentClass"
    >
      <div class="row w-50 img-fluid m-auto">
        <img
          v-bind:src="image"
          class="img-fluid"
          alt="question mark image"
        />
      </div>
      <div class="row bb-hdg mt-3 mb-1 justify-content-center text-center">
        {{ title }}
      </div>
      <div class="row bb-sub-hdg mt-3 mb-1 justify-content-center text-center">
        {{ message }}
      </div>
      <div
        v-if="subjectReadonly"
        class="row mt-3 mb-2 justify-content-center bb-confirm-subject-row"
      >
        <div class="form-group bb-confirm-subject-group">
          <div class="form-floating">
            <input
              :value="subject"
              class="form-control text-center bb-confirm-subject-input"
              type="text"
              :id="subjectInputId"
              readonly
              disabled
            />
            <label
              class="readonly bb-float-label optional"
              :for="subjectInputId"
              >{{ subjectLabel }}</label
            >
          </div>
        </div>
      </div>
      <div
        v-else
        class="row bb-sub-sub-hdg mt-2 mb-2 justify-content-center text-center bb-confirm-text-block"
      >
        {{ subject }}
      </div>
      <div
        class="btn-group special mt-4"
        role="group"
      >
        <button
          v-if="cancelButton"
          type="button"
          @click="_cancel"
          class="btn btn-lg btn-warning"
        >
          {{ cancelButton }}
        </button>
        <button
          v-if="okButton"
          type="button"
          @click="_confirm"
          class="btn btn-lg btn-primary"
        >
          {{ okButton }}
        </button>
      </div>
    </div>
  </PopUpModal>
</template>
<script>
import PopUpModal from './PopUpModal.vue'
import image from '../assets/images/bbQuestionMark96.png'

export default {
  name: 'ConfirmDialog',
  components: {
    PopUpModal,
  },
  data: () => ({
    title: undefined,
    message: undefined,
    subject: undefined,
    subjectReadonly: false,
    subjectLabel: 'Roll',
    subjectInputId: 'confirm-dialog-subject',
    okButton: undefined,
    cancelButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
    image,
    popupHorizontalAlign: 'center',
    popupHorizontalOffset: null,
    popupZIndex: 11000,
    contentClass: '',
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.subject = opts.subject
      this.subjectReadonly = Boolean(opts.subjectReadonly)
      this.subjectLabel = opts.subjectLabel || 'Roll'
      this.subjectInputId = opts.subjectInputId || 'confirm-dialog-subject'
      this.okButton = opts.okButton
      this.cancelButton = opts.cancelButton
      this.popupHorizontalAlign =
        opts.horizontalAlign ||
        (Number(opts.zIndex || 11000) > 11000 ? 'left' : 'center')
      this.popupHorizontalOffset = opts.horizontalOffset || null
      this.popupZIndex = opts.zIndex || 11000
      this.contentClass = opts.contentClass || ''
      this.$refs.popup?.open?.()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup?.close?.()
      this.popupHorizontalAlign = 'center'
      this.popupHorizontalOffset = null
      this.popupZIndex = 11000
      this.contentClass = ''
      this.resolvePromise?.(true)
    },

    _cancel() {
      this.$refs.popup?.close?.()
      this.popupHorizontalAlign = 'center'
      this.popupHorizontalOffset = null
      this.popupZIndex = 11000
      this.contentClass = ''
      this.resolvePromise?.(false)
    },
  },
}
</script>

<style scoped>
.bb-confirm-subject-row {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.bb-confirm-subject-group {
  width: min(100%, 14rem);
}

.form-floating > .bb-confirm-subject-input {
  min-height: calc(5rem + 2px);
  padding-top: 2rem;
  padding-bottom: 1rem;
  font-size: 2rem !important;
  font-weight: 700;
  line-height: 1.1;
}

.bb-confirm-text-block {
  white-space: pre-line;
}
</style>
